export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.02d60378aa205838128f1fa377de13a8.css";